import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { GlobalSettingsService } from '../globalSettings.service';
import { loginPath } from 'assets/consts';
import { Utils } from '@shared/utils.service';
import { ModalIcon, ModalKeys, NotificationService } from '@shared/notification/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { LogoutService } from '../../services/authentication/logout.service';
import { PlatformLoginStateService } from '../../services/platform-login/platform-login-state.service';

@Injectable()
export class RolesGuard {
	constructor(
		private readonly globalSettings: GlobalSettingsService,
		private readonly notificationService: NotificationService,
		private readonly translateService: TranslateService,
		private readonly router: Router,
		private readonly utils: Utils,
		private readonly logoutService: LogoutService,
		private readonly platformLoginStateService: PlatformLoginStateService
	) {}

	canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
		if (this.platformLoginStateService.isActive()) {
			return true;
		}

		const settings = this.globalSettings.get();
		const expectedRoles = route.data.expectedRoles;

		if (settings || route.data.allowAnonymous) {
			if (route.data.allowAnonymous || (expectedRoles && expectedRoles.indexOf(settings.roleType) > -1)) {
				return true;
			} else {
				const urlPath = this.utils.getUrlPath(this.router.url);
				const isLoginPageAndRoleChanged =
					urlPath === loginPath &&
					this.globalSettings.prevRoleType !== null &&
					settings.roleType !== this.globalSettings.prevRoleType;

				if (isLoginPageAndRoleChanged) {
					return this.router.createUrlTree([`/${this.globalSettings.rolePath()}/home`]);
				}
				this.notificationService.show(
					this.translateService.instant('ExpectedRoles.RolesWarningHeader'),
					this.translateService.instant('ExpectedRoles.RolesWarningMessage'),
					{ buttonCombination: ModalKeys.Ok, icon: ModalIcon.Info }
				);

				return this.router.createUrlTree([this.router.url]);
			}
		} else {
			return this.logoutService.logoutWithoutSessionInvalidation();
		}
	}
}
